import React, { useEffect, useContext } from 'react'
import { AuthContext } from '@/layout/Auth'
import { Message } from '@cx/ui'
import { TextField } from '@mui/material'
import { updateOrgInfo } from '@/api'
import { Controller, useForm } from 'react-hook-form'
import Modal2 from '@/components/Modal2'

interface EditSpaceNameModalProps {
  open: boolean
  onCancel: () => void
  onOk: () => void
}

const EditSpaceNameModal: React.FC<EditSpaceNameModalProps> = ({ open, onCancel, onOk }) => {
  const { authInfo } = useContext(AuthContext)
  const orgInfo = authInfo?.orgInfo
  const {
    control,
    formState: { errors },
    handleSubmit,
    setValue,
  } = useForm({
    defaultValues: {
      name: '',
    },
  })

  const onSubmit = handleSubmit((data) => {
    updateOrgInfo({ id: orgInfo?.id!, info: { name: data.name, description: orgInfo?.description! } }).then((res) => {
      onOk()
      onCancel()
      Message.success('修改成功')
    })
  })

  useEffect(() => {
    if (orgInfo?.name) {
      setValue('name', orgInfo.name)
    }
  }, [orgInfo?.name])

  return (
    <Modal2 title='空间名称修改' width={625} open={open} onCancel={onCancel} onOk={onSubmit}>
      <Controller
        rules={{ required: '请输入空间名称' }}
        name='name'
        control={control}
        render={({ field }) => (
          <TextField
            required
            {...field}
            variant='outlined'
            placeholder='请输入空间名称'
            label='空间名称'
            fullWidth
            error={Boolean(errors.name)}
            helperText={errors.name?.message as string}
            size='small'
            autoComplete='off'
          />
        )}
      />
    </Modal2>
  )
}

export default EditSpaceNameModal
